import React, { useMemo } from 'react'
import { SectionalTitleNameResponse } from '../../../api/bridgingFinance/searchPropertyBySectionalTitleName'
import { SearchBySecurityEstateNameResponse } from '../../../api/bridgingFinance/searchPropertyBySecurityEstateName'
import { EmptyMessage } from '../../kyc/EmptyMessage'
import '../SearchResultsTable.css'

export interface SearchBySecurityEstateNameResultsTableProps {
  entries?: SearchBySecurityEstateNameResponse[] | null
  title: string
  onRowClick?:
    | ((row: SearchBySecurityEstateNameResponse) => void)
    | ((row: SearchBySecurityEstateNameResponse) => Promise<void>)
}

export const SearchBySecurityEstateNameResultsTable: React.FC<
  SearchBySecurityEstateNameResultsTableProps
> = ({ entries, title, onRowClick }) => {
  const handleClick = (erf: SearchBySecurityEstateNameResponse) => () => {
    if (onRowClick) onRowClick(erf)
  }

  const showEmpty = useMemo(() => !entries, [entries])

  if (entries === undefined) return null

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <table>
        <thead>
          <tr style={{ height: '40px' }}>
            <th>Estate Name</th>
            <th>Suburb</th>
            <th>Municipality Name</th>
            {/* <th>Allotment</th>
          <th>CMA ID</th> */}
          </tr>
        </thead>
        <tbody>
          {showEmpty && <EmptyMessage />}
          {entries?.map((entry, index) => (
            <tr
              key={index}
              onClick={handleClick(entry)}
              style={{ height: '30px' }}
            >
              <td>{entry.complex}</td>
              <td>{entry.suburb}</td>
              <td>{entry.mun_name || '-'}</td>
              {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
